// billing strings (ar).
// Machine-drafted — review with a native speaker before launch.
const billing = {
	billing: {
		// Billing overview
		billingTitle: 'الفوترة',
		backToBilling: 'العودة إلى الفوترة',
		backToBillingLower: 'العودة إلى الفوترة',
		grabExclusiveDeals: 'احصل على عروضنا الحصرية %{type}',
		lifetime: 'مدى الحياة',
		monthly: 'شهري',
		insteadOfRegular: 'بدلاً من سعرنا المعتاد',
		regularPriceStrike: '9 دولارات لكل مستخدم/شهريًا',
		pricingSuffix: 'التسعير،',
		limitedTimeOffer: 'نقدم عرض الدفع مرة واحدة مدى الحياة لفترة محدودة فقط.',
		annual: 'سنوي',
		twentyPercentOff: 'خصم 20٪',

		// Plan detail
		noPlanSelected: 'لم يتم اختيار أي خطة',
		trialPeriod: 'الفترة التجريبية',
		upcomingInvoice: 'فاتورتك القادمة. سيتم تحصيل الرسوم منك بعد %{days}',
		days14: '14 يومًا.',
		days30: '30 يومًا.',
		days365: '365 يومًا.',
		notSubscribed: 'عزيزي المستخدم، أنت غير مشترك في أي خطة. يُرجى ترقية خطتك.',
		planLineItem: '%{members} مستخدم × خطة %{plan} (بسعر %{price} دولار)',
		noWord: 'لا',
		total: 'الإجمالي',
		upgradePlan: 'ترقية الخطة',
		managePayment: 'إدارة الدفع',
		cancelSubscription: 'إلغاء الاشتراك',

		// Cancel subscription confirmation
		areYouSure: 'هل أنت متأكد؟',
		cancelSubConfirm: 'هل تريد إلغاء اشتراكك الحالي؟',
		no: 'لا',
		yes: 'نعم',

		// Plan limits
		limits: 'الحدود',
		workspace: 'مساحة العمل',
		teamMembers: 'أعضاء الفريق',
		uniqueRecipients: 'المستلمون الفريدون',
		cards: 'البطاقات',
		aiCredits: 'أرصدة الذكاء الاصطناعي',
		emailAccountsLabel: 'حسابات البريد الإلكتروني',
		of: 'من',
		used: 'مستخدم',
		ofUnlimitedUsed: 'من غير محدود مستخدم',
		willBeRefreshed: 'سيتم تجديده في %{date}',
		lifetimeSubscription: 'لديك اشتراك خطة مدى الحياة.',
		recipientsLimitTooltip: 'حد المستلمين %{expiry}',
		cardsLimitTooltip: 'حد البطاقات %{expiry}',
		aiCreditsLimitTooltip: 'حد أرصدة الذكاء الاصطناعي %{expiry}',

		// Redeem codes
		cannotRedeemMore: 'لا يمكن استرداد أكثر من 8 أكواد',
		codeAlreadyAdded: 'تمت إضافة الكود بالفعل',
		enterAppsumoCodeTitle: 'أدخل كود AppSumo',
		hitPlusIcon: "اضغط على أيقونة '+' أو اضغط على Enter بعد كتابة الكود",
		planUpdated: 'تم تحديث الخطة!',
		redeem: 'استرداد',
		cancel: 'إلغاء',

		// Common swal titles
		successTitle: 'نجاح',
		errorTitle: 'خطأ',
		oopsTitle: 'عذرًا',

		// Receipts / data table
		receipts: 'الإيصالات',
		paymentHistory: 'سجل الدفع الخاص باشتراكك على CardClan',
		view: 'عرض',
		id: 'المعرّف',
		plan: 'الخطة',
		price: 'السعر',
		totalCards: 'إجمالي البطاقات',
		date: 'التاريخ',

		// Change plan
		changePlan: 'تغيير الخطة',

		// Email accounts list
		emailsTitle: 'رسائل البريد الإلكتروني',
		connectEmailAccount: 'ربط حساب بريد إلكتروني',
		connectEmailAccountBtn: 'ربط حساب بريد إلكتروني',
		needHelpConnecting: 'هل تحتاج إلى مساعدة في ربط حساب البريد الإلكتروني؟',
		successfullyDeleted: 'تم الحذف بنجاح',
		deleteAccountError: 'حدث خطأ أثناء حذف حسابك. يُرجى المحاولة مرة أخرى!',
		noEmailAccountLimit: 'خطتك لا تسمح بإنشاء حسابات بريد إلكتروني. يُرجى ترقية خطتك لإضافة حسابات بريد إلكتروني.',
		noEmailAccounts: 'لم يتم ربط أي حسابات بريد إلكتروني بعد.',
		getStartedConnecting: 'ابدأ بربط حساب بريد إلكتروني جديد.',
		howToSetupSmtp: 'كيفية إعداد حساب مرسل SMTP؟',

		// Email account modal
		editEmailAddress: 'تعديل عنوان البريد الإلكتروني',
		addEmailAddress: 'إضافة عنوان بريد إلكتروني',
		fromName: 'اسم المرسل',
		userName: 'اسم المستخدم',
		smtpHost: 'مضيف SMTP',
		differentReplyTo: 'تعيين عنوان رد مختلف',
		fromEmail: 'بريد المرسل',
		passwordLabel: 'كلمة المرور',
		smtpPort: 'منفذ SMTP',
		ssl: 'SSL',
		tls: 'TLS',
		replyTo: 'الرد إلى',
		updateSettings: 'تحديث الإعدادات',
		saveSettings: 'حفظ الإعدادات',
		accountUpdated: 'تم تحديث حساب بريدك الإلكتروني بنجاح',
		accountConnected: 'تم ربط حساب بريدك الإلكتروني بنجاح',
		minChars: 'يجب أن يتكون من حرفين على الأقل ',
		maxChars: 'يجب ألا يتجاوز 25 حرفًا ',
		invalidEmail: 'تنسيق البريد الإلكتروني غير صالح',
		emailRequired: 'البريد الإلكتروني مطلوب',
		port25Blocked:
			'طلبات البريد الإلكتروني عبر المنفذ 25 محظورة من قِبل خوادم المضيف. يُنصح باستخدام منفذ آخر لهذه العملية.',

		// Email account table
		name: 'الاسم',
		status: 'الحالة',
		action: 'الإجراء',
		active: 'نشط',
		edit: 'تعديل',
		deleteWord: 'حذف',

		// White label
		whiteLabel: 'العلامة البيضاء',
		noCustomDomain: 'لم تقم بإعداد نطاقك المخصص بعد.',
		brandPresets: 'إعدادات العلامة التجارية',
		brandingDescription: 'هذه هي علامتك التجارية التي ستظهر في جميع أنحاء المنصة',
		appTitle: 'عنوان التطبيق',
		appTitlePlaceholder: 'مثال: my-app',
		brandColorsTitle: 'ألوان العلامة التجارية',
		reset: 'إعادة تعيين',
		save: 'حفظ',
		clickSaveToUpdate: 'يُرجى النقر على زر الحفظ لتحديث تغييراتك.',
		invalidFile: 'ملف غير صالح!',
		uploadLogo: 'رفع الشعار',
		uploadImage: 'رفع صورة',
		uploading: 'جارٍ الرفع...',

		// Logo / color labels
		darkLogo: 'الشعار الداكن',
		lightLogo: 'الشعار الفاتح',
		favicon: 'أيقونة الموقع',
		accentColor: 'لون التمييز',
		backgroundColor: 'لون الخلفية',
		sidebarColor: 'لون الشريط الجانبي',

		// Workspace domain
		workspaceDomain: 'نطاق مساحة العمل',
		loading: 'جارٍ التحميل...',
		domainsUsed: 'تم استخدام %{used} من %{limit} من نطاقات مساحة العمل',
		customDomainFor: 'نطاق مخصص لـ "%{name}"',
		currentWorkspaceFallback: 'مساحة العمل الحالية',
		assignDomainDesc: 'خصّص نطاقًا مخصصًا لمساحة العمل هذه لروابط بطاقات تحمل علامتك التجارية',
		domainName: 'اسم النطاق',
		saveDomain: 'حفظ النطاق',
		checkDns: 'التحقق من DNS',
		cnameInstructions:
			'أضف سجل CNAME التالي في إعدادات DNS الخاصة بك. يمكن لمسؤول الموقع أو مسؤول الخادم مساعدتك في إعداد ذلك.',
		typeCol: 'النوع',
		keyCol: 'المفتاح',
		valueCol: 'القيمة',
		copy: 'نسخ',
		invalidDomain: 'نطاق غير صالح. لا تضمّن البروتوكول (http/https)',
		domainRequired: 'النطاق مطلوب',
		domainCreated: 'تم إنشاء نطاق مساحة العمل. يُرجى تكوين DNS والتحقق منه.',
		failedCreateDomain: 'فشل إنشاء النطاق',
		domainVerified: 'تم التحقق من النطاق بنجاح! أصبح نشطًا الآن.',
		verificationFailed: 'فشل التحقق',
		dnsVerificationFailed: 'فشل التحقق من DNS. تأكد من أن CNAME يشير إلى ssl.cardclan.me',
		deletedTitle: 'تم الحذف',
		domainRemoved: 'تمت إزالة نطاق مساحة العمل.',
		failedDeleteDomain: 'فشل حذف النطاق',

		// Workspace domain add-on
		addonTitle: 'إضافة النطاقات المخصصة لمساحات العمل',
		addonDesc:
			'خصّص نطاقات مخصصة فريدة لمساحات عمل فردية. يمكن لكل مساحة عمل أن يكون لها نطاقها الخاص الذي يحمل علامتها التجارية لروابط البطاقات.',
		addonHeading: 'النطاقات المخصصة لمساحات العمل',
		addonSubDesc: 'كل وحدة تمنحك 3 نطاقات مخصصة لمساحة العمل. اضبط الكمية للحصول على المزيد.',
		perMonth: '/شهريًا',
		workspaceDomainsCount: '%{count} من نطاقات مساحة العمل',
		featureDomainsPerUnit: '3 نطاقات مخصصة لمساحة العمل لكل وحدة',
		featureDnsVerification: 'التحقق من DNS باستخدام CNAME',
		featureAdjustableQty: 'كمية قابلة للتعديل عند الدفع',
		purchaseAddon: 'شراء الإضافة',

		// Video card settings
		videoCardSettingsPageTitle: 'إعدادات بطاقات الفيديو | CardClan',
		videoCards: 'بطاقات الفيديو',
		videoCardsDesc: 'تحكّم في ما إذا كانت بطاقات الفيديو متاحة لأعضاء مساحة العمل هذه.',
		enableVideoCards: 'تفعيل بطاقات الفيديو',
		enableVideoCardsDesc:
			'عند التعطيل، لا يمكن لأعضاء مساحة العمل إنشاء بطاقات فيديو أو الوصول إلى قسم بطاقات الفيديو.',
		saved: 'تم الحفظ!',
		failedSave: 'فشل الحفظ',
		enabled: 'مُفعّل',
		disabled: 'مُعطّل',

		// Integration key
		generateIntegrationKey: 'إنشاء مفتاح التكامل',
		integrationKeyDesc: 'استخدم هذا المفتاح للاتصال بمنصات الأتمتة الخارجية مثل Pabbly Connect',
		integrationKeyCreated: 'تم إنشاء مفتاح التكامل بنجاح.',
		usageInstructions: 'تعليمات الاستخدام:',
		usageStep1: 'انسخ هذا المفتاح إلى الحافظة',
		usageStep2: 'في Pabbly Connect، أنشئ اتصالاً جديدًا',
		usageStep3: 'الصق هذا المفتاح كرمز Bearer أو مفتاح API',
		integrationKeyExists: 'مفتاح التكامل موجود بالفعل',
		integrationKeyExistsDesc:
			'لديك بالفعل مفتاح تكامل لمنصة مختلفة. يمكنك امتلاك مفتاح تكامل واحد فقط لكل حساب.',
		integrationKeyGenerated: 'تم إنشاء مفتاح التكامل بنجاح!',
		failedGenerateIntegrationKey: 'فشل إنشاء مفتاح التكامل',
		integrationKeyCopied: 'تم نسخ مفتاح التكامل بنجاح',

		// Zapier key
		generateZapierKey: 'إنشاء مفتاح Zapier',
		generateZapierKeyBtn: 'إنشاء مفتاح Zapier',
		zapierKeyDesc: 'استخدم هذا المفتاح في تطبيق Zapier الخاص بك للمصادقة',
		zapierKeyCreated: 'تم إنشاء مفتاح Zapier بنجاح.',
		keyCopied: 'تم نسخ مفتاح %{title} بنجاح',

		// Preview card
		previewCard: 'معاينة البطاقة',
		previewCardDesc: 'خصّص شكل بطاقتك في البريد الإلكتروني وعند فتحها.',
		chooseCardBackground: 'اختر خلفية البطاقة',
		background: 'الخلفية',
		toggleConfetti: 'تبديل القصاصات الورقية',
		addCompanyLogo: 'إضافة شعار الشركة',
		logoDimensionNote: '* للحصول على أفضل عرض لشعار الشركة، يجب أن تكون الأبعاد 400 × 100',
		viewCardButtonDesign: 'تصميم زر «عرض البطاقة» في البريد الإلكتروني',
		preview: 'معاينة',
		buttonText: 'نص الزر',
		buttonRounded: 'زر مدور',
		buttonColor: 'لون الزر',
		saveChanges: 'حفظ التغييرات',
		viewChanges: 'عرض التغييرات',
		changesSaved: 'تم حفظ التغييرات بنجاح.',
		previewGreeting: 'مرحبًا الاسم، قام %{name} بإنشاء بطاقة رقمية',
		previewFooter: 'وصل إلى بريدك الوارد للتو توصيل خاص. اعرض بطاقتك عبر الإنترنت.',

		// Settings navigation
		navYourProfile: 'ملفك الشخصي',
		navBilling: 'الفوترة',
		navManageWorkspaces: 'إدارة مساحات العمل',
		navBasicSettings: 'الإعدادات الأساسية',
		navTeamMembers: 'أعضاء الفريق',
		navEmailAccounts: 'حسابات البريد الإلكتروني',
		navCustomDomainSettings: 'إعدادات النطاق المخصص',
		navDashboard: 'لوحة التحكم',
		navMyCards: 'بطاقاتي',
		navSettings: 'الإعدادات',
		accountSettings: 'إعدادات الحساب',
		whiteLabelSettingsSection: 'إعدادات العلامة البيضاء',
	},
};
export default billing;
